import { render, staticRenderFns } from "./CookieConsentModal.vue?vue&type=template&id=554ec61a&scoped=true"
import script from "./CookieConsentModal.vue?vue&type=script&lang=js"
export * from "./CookieConsentModal.vue?vue&type=script&lang=js"
import style0 from "./CookieConsentModal.vue?vue&type=style&index=0&id=554ec61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554ec61a",
  null
  
)

export default component.exports